




































import { Component, Prop } from 'vue-property-decorator'
import { DirectiveBinding } from 'vue/types/options'
import { VNode } from 'vue/types/umd'

import {
  ButtonView,
  NodeWrapper,
  RowButtonView,
} from '../../../../../../components'
import { SampleNodeMixin } from '../../../../index'
import { RandomizerNode } from '../../index'

@Component({
  components: {
    ButtonView,
    NodeWrapper,
    RowButtonView
  },
  directives: {
    socket: {
      bind(el: HTMLElement, binding: DirectiveBinding, vnode: VNode) {
        (vnode.context as any).bindSocket(el, binding.arg, binding.value);
      },
      update(el: HTMLElement, binding: DirectiveBinding, vnode: VNode) {
        (vnode.context as any).bindSocket(el, binding.arg, binding.value);
      }
    },
  }
})
export default class SampleRandomizerNode extends SampleNodeMixin {
  @Prop() node!: RandomizerNode
}
